<template>
  <div style="display:inline-flex">
      <div class="type-tabs">
      <div
        v-for="option in options"
        :key="option.value"
        class="type-tab-item"
        :class="{ active: value === option.value }"
        @click="handleTabClick(option.value)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTabs',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleTabClick(val) {
      if (this.value !== val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.type-tabs {
  display: flex;
  align-items: center;
  background: #ecf0f7;
  padding: 4px;
  border-radius: 4px;
}

.type-tab-item {
  padding: 2.5px 16px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  user-select: none;

  &:hover {
    color: #333;
  }

  &.active {
    background: #fff;
    color: #333;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
}
</style>
